import React from 'react';
import './SunDesigns.css';

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z" />
    <circle cx="12" cy="10" r="2.6" />
  </svg>
);

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="12" cy="13" r="3.4" />
    <path d="M12 4v2M5 13H3M21 13h-2M6.5 7.5 5 6M17.5 7.5 19 6M3 19h18" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
    <path d="M20 14a8 8 0 1 1-9.9-9.9A7 7 0 0 0 20 14Z" />
  </svg>
);

// 06 · Yumuşak — Neumorfizm · kabartma yüzey
const D6Yumusak = ({ vm }) => {
  const caption = vm.isDst ? 'yaz saati' : 'saat';
  return (
    <div className="gsk">
      <div className="stage">
        <div className="d6">
          <div className="d6-head">
            <span className="d6-loc"><PinIcon /> {vm.location}</span>
            <span className="d6-date">{vm.dateShort}</span>
          </div>
          <div className="d6-grid">
            <div className="d6-card d6-card--rise">
              <div className="d6-row">
                <span className="d6-ico d6-ico--rise"><SunIcon /></span>
                <div className="d6-name">Güneşin Doğuşu<small>Sunrise</small></div>
              </div>
              <div className="d6-disp"><div className="t">{vm.sunriseDst}</div><div className="c">{caption}</div></div>
              <div className="d6-seg">
                {vm.isDst ? (
                  <>
                    <div className="on">Yaz Saati<small>{vm.sunriseDst}</small></div>
                    <div>Standart<small>{vm.sunriseNormal}</small></div>
                  </>
                ) : (
                  <div className="on">Standart<small>{vm.sunriseDst}</small></div>
                )}
              </div>
            </div>
            <div className="d6-card d6-card--set">
              <div className="d6-row">
                <span className="d6-ico d6-ico--set"><MoonIcon /></span>
                <div className="d6-name">Güneşin Batışı<small>Sunset</small></div>
              </div>
              <div className="d6-disp"><div className="t">{vm.sunsetDst}</div><div className="c">{caption}</div></div>
              <div className="d6-seg">
                {vm.isDst ? (
                  <>
                    <div className="on">Yaz Saati<small>{vm.sunsetDst}</small></div>
                    <div>Standart<small>{vm.sunsetNormal}</small></div>
                  </>
                ) : (
                  <div className="on">Standart<small>{vm.sunsetDst}</small></div>
                )}
              </div>
            </div>
          </div>
          <p className="d6-note">{vm.dstNote}</p>
        </div>
      </div>
    </div>
  );
};

export default D6Yumusak;
